import { Sensor, useHVACData } from 'common';
import { useTranslation } from 'react-i18next';
import { YStack, Text, XStack } from 'tamagui';
import { tokens } from 'tamagui-config/src/tokens';

import { HubLineChart } from '../../../components/common/HubLineChart';
import { LoadingOverlay } from '../../../components/common/LoadingOverlay';

interface HVACTemperatureContentProps {
  sensor?: Sensor;
}

export const HVACTemperatureContent: React.FC<HVACTemperatureContentProps> = ({ sensor }) => {
  const { t } = useTranslation();
  const { temperatureData, currentTemperature, loading } = useHVACData(sensor);
  const temperatureUnit = '°F';

  return (
    <YStack position="relative" flex={1}>
      <LoadingOverlay isVisible={loading} />

      {!loading && currentTemperature === undefined && temperatureData.length === 0 && (
        <XStack flex={1} justifyContent="center" alignItems="center">
          <Text fontSize="$6" color={tokens.color.textLight} textAlign="center">
            {t('hvac.noTemperatureData')}
          </Text>
        </XStack>
      )}

      {currentTemperature !== undefined && (
        <Text fontFamily="$heading" fontWeight="$9.5" fontSize="$9.5" color={tokens.color.white12}>
          {Number(currentTemperature).toFixed(0)} {temperatureUnit}
        </Text>
      )}

      {temperatureData.length > 0 && (
        <HubLineChart data={temperatureData as any} unit={temperatureUnit} />
      )}
    </YStack>
  );
};
